export default function populateShippingAddressData(
  billingAddress = {},
  profileData,
  organizationData,
) {
  const address = {
    type: 'SHIPPING_ADDRESS',
    city: billingAddress.city,
    country: billingAddress.country,
    street: billingAddress.street,
    postcode: billingAddress.postcode,
    number: billingAddress.number,
    number_suffix: billingAddress?.numberSuffix,
    mail_lines: billingAddress?.mailLines || billingAddress?.mail_lines,
    is_po_box: billingAddress?.isPoBox || false,
    profile_id: profileData?.profile_id,
  };
  if (profileData) {
    address.profile_id = profileData?.profile_id;
  }
  if (organizationData) {
    address.organization_id = organizationData?.organization_id;
  }
  return address;
}
